import React, { useContext } from "react";
import { MessageBar, MessageBarType } from "@fluentui/react";
import { useIntl } from "react-intl";
import { freemiumMessages } from "../messages";
import { ProductContext } from "../../../contexts/product-context";

export const AgreementBanner = () => {
  const intl = useIntl();
  const product = useContext(ProductContext);
  return (
    <MessageBar
      messageBarType={MessageBarType.info}
      truncated={true}
      styles={{
        root: {
          margin: "10px 0 10px 0 !important",
        },
      }}
    >
      {product?.isHosted
        ? intl.formatMessage(freemiumMessages.agreementBannerTxtHosted)
        : intl.formatMessage(freemiumMessages.agreementBannerTxt)}
    </MessageBar>
  );
};
